import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { GridTabs } from "../grid/gridTabs";
import "./mainBox.css";
import RolesMainBox from "../Roles/rolesMainBox";
import FilesMainBox from "../Files/filesMainBox";
import { GlobalGrid } from "../../GlobalGrid";
import MainSelector from "../grid/mainSelector";
import { globalGridFilterChanged, onChangeSelectedCategory } from "../../actions";
import { changedMenu } from "../../actions/menu";
import { MENU_MAIN_SELECTOR, MENU_FILES, MENU_ROLES, MENU_GLOBAL_GRID, MENU_GRID_TABS, MENU_GRID_RENDER, MENU_EXCLUSIONS } from "../../actions/menuTypes";
import { GlobalGridRenderer } from "../../components/globalGrid/globalGridRenderer";
import { Exclusions } from "../../components/Exclusions/Exclusions";
import { getGridTemplatesByUser } from "../../actions/gridTemplates/gridTemplatesActions";

export const MainBox = () => {
  const dispatch = useDispatch();
  const menuId = useSelector((state) => state.menu.selectedMenu);
  const authenticatedUser = useSelector(state => state.userInfo.userAuthenticated);

  const onMainSelectorChange = (e) => {
    dispatch(changedMenu(MENU_MAIN_SELECTOR));
    dispatch(onChangeSelectedCategory(e));
  }

  const onApplyFilter = (filter) => {
    dispatch(globalGridFilterChanged('/api/Items/itemColumnsMassiveFilter', filter));
  }

  const saveSelectedTemplatesInLocalStorage = async () => {
    var templates = await getGridTemplatesByUser(authenticatedUser.id);
    templates.forEach(template => {
        if (localStorage.getItem(`storageKey-${template.programId}-${template.categoryId}`) === null) {
          localStorage.setItem(`storageKey-${template.programId}-${template.categoryId}`, template.template );
        }
    });
  }
  useEffect(() => {
    saveSelectedTemplatesInLocalStorage();
  }, []);

  switch (menuId) {
    case MENU_MAIN_SELECTOR:
      return <MainSelector onChange={onMainSelectorChange} onApplyFilter={onApplyFilter} />;
    case MENU_FILES:
      return <FilesMainBox />;
    case MENU_ROLES:
      return <RolesMainBox />;
    case MENU_GLOBAL_GRID:
      return <GlobalGrid />;
    case MENU_GRID_TABS:
      return <GridTabs />;
    case MENU_GRID_RENDER:
      return <GlobalGridRenderer />;
    case MENU_EXCLUSIONS:
      return <Exclusions />;
    default:
      return null;
  }


};
